/**
 * The number of unique hashes.
 */
const M = 1000000000

/**
 * Modulo-hash algorithm for fast data comparison.
 *
 * WARNING: do not use this in security-related contexts; it's
 * intended for fast, approximate comparisons of strings.  It's useful
 * for data structures like hash tables and for checking equality with
 * remote data without transmitting the entire string.
 *
 * @param {String} s
 * @return {number}
 */
export const moduloStringHash = (s) => {
  let hash = 0
  const R = 31
  for (let i = 0; i < s.length; i++) {
    const charCode = s.codePointAt(i)
    if (charCode) {
      hash = (R * hash + charCode) % M
    }
  }
  return hash
}

/**
 * Produce a clone of the provided object whose keys are sorted
 * alphabetically recursively.  Arrays keep the same order, but
 * objects within them may receive a different order.
 *
 * @param {any} x
 * @return {any}
 */
function withSortedKeys(x) {
  if (Array.isArray(x)) {
    return x.map(withSortedKeys)
  } else if (x && typeof x === 'object') {
    const keys = Object.keys(x)
    keys.sort()
    return keys.reduce((acc, next) => {
      return {
        ...acc,
        [next]: withSortedKeys(x[next]),
      }
    }, {})
  } else {
    return x
  }
}

/**
 * Produce an efficient hash for the provided Javascript data by first
 * serialising it and then computing the modulo hash of the resulting
 * string.
 *
 * @param {any} x
 * @return {number}
 */
export const moduloJsonHash = (x) => {
  return moduloStringHash(JSON.stringify(withSortedKeys(x)))
}
